class AvvioAccordion {
	constructor(options) {
	  this.options = Object.assign(
		{
		  item: ".js-avvio-accordion",
		  header: ".js-avvio-accordion__trigger",
		  content: ".js-avvio-accordion__content",
		  activeClass: "is-active",
		},
		options
	  );
  
	  this.items = document.querySelectorAll(this.options.item);
	  this.defaultActiveTarget = document.querySelectorAll(
		this.options.header + "." + this.options.activeClass
	  );
	  this.isEventCall = false;
	  this.currentTarget = null;
	  this.currentItem = null;
	  this.currentSlideContent = null;
	  this.siblings = null;
	  this.panelSiblings = null;
	  this.isActive = null;
	  this.updatedSlideHeight = 0;
	  this.isToggleEnabled = true;
	}
  
	getSiblings(target, filterClass, exceptForTheCurrentTarget) {
	  if (!target) return false;
  
	  return [...target.parentNode.children].filter((item) => {
		if (exceptForTheCurrentTarget) {
		  return item != target && item.classList.contains(filterClass);
		} else {
		  return item.classList.contains(filterClass);
		}
	  });
	}
  
	updateClassAndAttributes(currentTarget, currentItem, showState) {
	  const { activeClass } = this.options;
  
	  if (typeof showState !== "boolean") return false;
  
	  let classState = showState ? "add" : "remove";
  
	  currentTarget.setAttribute("aria-expanded", showState);
	  currentTarget.classList[classState](activeClass);
	  currentItem && currentItem.classList[classState](activeClass);
	}
  
	toggleClass() {
	  const { header, activeClass } = this.options;
  
	  // Toggle class into current item
	  if (this.isActive) {
		this.updateClassAndAttributes(this.currentTarget, this.currentItem, true);
	  } else {
		this.updateClassAndAttributes(this.currentTarget, this.currentItem, false);
	  }
  
	  // Remove active class from siblings
	  for (let item of this.siblings) {
		if (item != this.currentItem && item.classList.contains(activeClass)) {
		  // Update sibling content slide class and attributes
		  const trigger = item.querySelector(header);
		  this.updateClassAndAttributes(trigger, item, false);
		}
	  }
  
	  return true;
	}
  
	updateSlideHeightRecursive = (targetedSlide, slideType) => {
	  const { content } = this.options;
	  const closestSlideContent = targetedSlide.parentNode.closest(content);
	  if (closestSlideContent) {
		if (slideType === "slideDown") {
		  closestSlideContent.style.maxHeight =
			parseInt(closestSlideContent.style.maxHeight) + this.updatedSlideHeight + "px";
  
		  // Recursive - Update the parent
		  this.updateSlideHeightRecursive(closestSlideContent, "slideDown");
		} else {
		  closestSlideContent.style.maxHeight =
			parseInt(closestSlideContent.style.maxHeight) - this.updatedSlideHeight + "px";
  
		  // Recursive - Update the parent
		  this.updateSlideHeightRecursive(closestSlideContent);
		}
	  }
	};
  
	updatePanelClassAndAttributes(targetedSlideContent, showState) {
	  const { activeClass } = this.options;
  
	  if (typeof showState !== "boolean") return false;
  
	  let classState = showState ? "add" : "remove";
  
	  showState
		? targetedSlideContent.removeAttribute("hidden")
		: targetedSlideContent.setAttribute("hidden", "");
  
	  targetedSlideContent.classList[classState](activeClass);
	}
  
	slideUp(targetedSlideContent) {
	  if (!targetedSlideContent) return false;
  
	  this.updatePanelClassAndAttributes(targetedSlideContent, false);
  
	  this.updatedSlideHeight = targetedSlideContent.scrollHeight;
  
	  targetedSlideContent.style.maxHeight = "0";
  
	  // Update the height of the parent slide if it exists
	  this.updateSlideHeightRecursive(targetedSlideContent);
	}
  
	slideDown(targetedSlideContent) {
	  if (!targetedSlideContent) return false;
  
	  this.updatePanelClassAndAttributes(targetedSlideContent, true);
  
	  targetedSlideContent.style.maxHeight = targetedSlideContent.scrollHeight + "px";
  
	  this.updatedSlideHeight = targetedSlideContent.scrollHeight;
  
	  // Update the height of the parent slide if it exists
	  this.updateSlideHeightRecursive(targetedSlideContent, "slideDown");
	}
  
	toggleSlide(targetedPanel, targetedPanelSiblings) {
	  const { content } = this.options;
  
	  // Toggle Slide
	  this.currentSlideContent = targetedPanel
		? targetedPanel
		: this.currentItem.querySelector(content);
  
	  if (!this.currentSlideContent) return false;
  
	  if (this.isActive) {
		this.slideDown(this.currentSlideContent);
	  } else {
		this.slideUp(this.currentSlideContent);
	  }
  
	  // Slide Up in siblings
	  const slideUpInSiblings = (items, isParentNode) => {
		for (let item of items) {
		  if (item != this.currentItem) {
			const siblingSlideContent = isParentNode ? item.querySelector(content) : item;
  
			this.slideUp(siblingSlideContent);
		  }
		}
	  };
  
	  if (targetedPanelSiblings) {
		slideUpInSiblings(targetedPanelSiblings);
	  } else {
		slideUpInSiblings(this.siblings, true);
	  }
  
	  return true;
	}
  
	specificSplitAccordion(currentTarget, currentItem) {
	  const { activeClass, content, item: itemSelector } = this.options;
  
	  // Check for specific panel
	  const targetPanelId = currentTarget.getAttribute("aria-controls");
	  const targetedPanel = document.querySelector(`#${targetPanelId}`);
  
	  // Return if targeted panel is not there
	  if (!targetedPanel) return false;
  
	  const headerSiblings = this.getSiblings(currentItem, itemSelector.slice(1), true);
	  const panelSiblings = this.getSiblings(targetedPanel, content.slice(1), true);
  
	  const isActive = !this.isEventCall
		? true
		: currentTarget.classList.contains(activeClass)
		? false
		: true;
  
	  // Update global variables
	  this.currentTarget = currentTarget;
	  this.currentItem = currentItem;
	  this.siblings = headerSiblings;
	  this.panelSiblings = panelSiblings;
	  this.isActive = isActive;
  
	  // Toggle class, attributes and slide
	  if (this.toggleSlide(targetedPanel, panelSiblings) && this.toggleClass()) {
		return true;
	  }
	}
  
	defaultAccordion(currentTarget, currentItem) {
	  const { activeClass, item: itemSelector } = this.options;
  
	  if (!currentItem) return false;
  
	  const siblings = this.getSiblings(currentItem, itemSelector.slice(1), true);
  
	  // Return if not siblings
	  if (!siblings) return false;
  
	  const isActive = !this.isEventCall
		? true
		: currentItem.classList.contains(activeClass)
		? false
		: true;
  
	  // Update global variables
	  this.currentTarget = currentTarget;
	  this.currentItem = currentItem;
	  this.siblings = siblings;
	  this.panelSiblings = null;
	  this.isActive = isActive;
  
	  // Toggle class, attributes and slide
	  if (this.toggleSlide() && this.toggleClass()) {
		return true;
	  }
	}
  
	invokeAccordion = (e) => {
	  const { target } = e;
	  const { header, activeClass } = this.options;
  
	  if (!target.classList.contains(header.slice(1))) return false;
  
	  if (e.type === "keypress") {
		const key = e.which || e.keyCode;
		if (key !== 13) return false;
	  }
  
	  // check for event call or functional call
	  if (!!e.preventDefault) {
		e.preventDefault();
		this.isEventCall = true;
	  } else {
		this.isEventCall = false;
	  }
  
	  const { item: itemSelector } = this.options;
  
	  let currentItem = target.closest(itemSelector);
  
	  // check for the toggle is enabled or not and update global state variable
	  this.isToggleEnabled = target.dataset.avvioAccordionToggle === "false" ? false : true;
  
	  // Return if toggle disabled and the current item is active
	  if (!this.isToggleEnabled && this.isEventCall && target.classList.contains(activeClass))
		return false;
  
	  // Call Specific Split Accordion if anything goes wrong with the Default Accordion
	  !this.defaultAccordion(target, currentItem) && this.specificSplitAccordion(target, currentItem);
  
	  return true;
	};
  
	activateDefaultActiveItems() {
	  this.defaultActiveTarget?.forEach((item) => {
		this.invokeAccordion({ target: item });
	  });
	}
  
	/**
	 * Validate, Create Instance, and Initialize Accordion
	 * @returns boolean
	 */
	init() {
	  // Return false if there are no valid items
	  if (!this.items) return false;
  
	  this.activateDefaultActiveItems();
  
	  document.addEventListener("click", this.invokeAccordion, false);
	  document.addEventListener("keypress", this.invokeAccordion, false);
  
	  return true;
	}
  }
  
  const avvioAccordion = new AvvioAccordion({
	item: ".js-avvio-accordion",
	header: ".js-avvio-accordion__trigger",
	content: ".js-avvio-accordion__content",
	activeClass: "is-active",
  });
  
  /**
   * Initialize the script when the block is previewed within the editor
   * https://www.advancedcustomfields.com/resources/javascript-api/
   */
  if (window.acf) {
	window.acf.addAction("render_block_preview/type=avvio-accordion", avvioAccordion.init);
  } else {
	window.addEventListener("load", () => {
	  avvioAccordion.init();
	});
  }
  